export default {
    name: "Project Xanadu - CSFDB",
    main: "https://www.csfdb.cn",
    server: "https://www.csfdb.cn:3001/",
    wechat: {
        appId: "wx0061916b6b54baf4"
    },
    accessToken: 'fc1179ab-84ac-4168-87c7-b27220fd2813'
}
